import { Stack, Typography, Button, IconButton, Box } from '@mui/joy';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { getFirstDayOfMonth } from '@/utils/datetime';

export function MonthlyCalendarHeader({ currentMonth, onMonthChange }) {
  function goToPreviousMonth() {
    const newDate = new Date(currentMonth);
    newDate.setMonth(newDate.getMonth() - 1);
    onMonthChange(newDate);
  }

  function goToNextMonth() {
    const newDate = new Date(currentMonth);
    newDate.setMonth(newDate.getMonth() + 1);
    onMonthChange(newDate);
  }

  function goToToday() {
    onMonthChange(getFirstDayOfMonth());
  }

  function formatMonthName() {
    return currentMonth.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Button variant="soft" color="neutral" sx={{ borderRadius: '36px' }} onClick={goToToday}>Today</Button> 
      <Stack direction="row" gap={2} alignItems="center" sx={{ minWidth: '225px' }} justifyContent="space-between">
        <IconButton onClick={goToPreviousMonth} size="sm" sx={{ borderRadius: '36px' }}>
          <ChevronLeft />
        </IconButton>
        <Typography level="title-md">{formatMonthName()}</Typography>
        <IconButton onClick={goToNextMonth} size="sm" sx={{ borderRadius: '36px' }}>
          <ChevronRight />
        </IconButton>
      </Stack>      
    </Box>
  );
}

